/** How often the UI calls StudioBackendRoutes.AUTH_SESSION to slide the login cookie forward. */
export const STUDIO_SESSION_KEEPALIVE_MS = 15 * 60 * 1000;
